import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useFormik } from "formik";
import * as yup from "yup";
import image from "../assets/logo_navecuador.PNG";
import { useLoginMutation } from "../services/auth/authService";
import { CircularProgress, IconButton } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { useState } from "react";

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/">
        BlackBox Ec
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: `url("${image}")`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "15%",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const LoginScreen = () => {
  const classes = useStyles();
  const [showPass, setShowPass] = useState(false);
  const [login, { isError, error, isLoading, reset }] = useLoginMutation();

  const loginSchema = yup.object().shape({
    email: yup
      .string()
      .email("Ingrese un correo válido")
      .required("El email es requerido"),
    password: yup.string().required("La contraseña es requerida"),
  });

  const { errors, getFieldProps, touched, handleSubmit } = useFormik({
    initialValues: {
      // email: "edmundo@gmail.com",
      // password: "123456",
      email: "",
      password: "",
    },
    validationSchema: loginSchema,
    onSubmit: (values) => {
      login({
        email: values.email,
        contrasenia: values.password,
      });
    },
  });

  const submitForm = () => {
    handleSubmit();
  };

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={5} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" style={{ fontWeight: 600 }}>
            Ingresar
          </Typography>
          <TextField
            placeholder="Ingrese email"
            variant="outlined"
            margin="normal"
            fullWidth
            {...getFieldProps("email")}
            error={Boolean(errors.email && touched.email)}
            helperText={Boolean(errors.email && touched.email) && errors.email}
          />
          <TextField
            placeholder="Ingrese contraseña"
            variant="outlined"
            margin="normal"
            fullWidth
            type={showPass ? "text" : "password"}
            {...getFieldProps("password")}
            error={Boolean(errors.password && touched.password)}
            helperText={
              Boolean(errors.password && touched.password) && errors.password
            }
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => setShowPass(!showPass)}>
                  {!showPass ? <IconEye /> : <IconEyeOff />}
                </IconButton>
              ),
            }}
          />
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginBottom: 10, width: "100%" }}
          >
            {isError && error && (
              <Alert severity="error" onClose={reset}>
                {"data" in error ? `${error.data}` : undefined}
              </Alert>
            )}
          </Grid>
          <Button
            size="large"
            fullWidth
            variant="contained"
            color="primary"
            onClick={submitForm}
            disabled={isLoading}
            endIcon={
              isLoading && <CircularProgress color="inherit" size={20} />
            }
          >
            Ingresar
          </Button>

          <Box mt={5}>
            <Copyright />
          </Box>
        </div>
      </Grid>
    </Grid>
  );
};

export default LoginScreen;
